import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import TokenService from "../services/token.service";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { differenceInMinutes } from 'date-fns';
import { getConfig } from './config';
import { isSuperUser } from './userUtils';
import i18n, { idiomaAtual } from '../i18n';

const SECRET_KEY = 'N`3"p2Kc7[psy)X'; 

export const estados = {
    "AC": "Acre",
    "AL": "Alagoas",
    "AP": "Amapá",
    "AM": "Amazonas",   
    "BA": "Bahia",
    "CE": "Ceará",
    "DF": "Distrito Federal",
    "ES": "Espírito Santo",
    "GO": "Goiás",
    "MA": "Maranhão",   
    "MT": "Mato Grosso",
    "MS": "Mato Grosso do Sul",
    "MG": "Minas Gerais",
    "PA": "Pará",
    "PB": "Paraíba",
    "PR": "Paraná", 
    "PE": "Pernambuco",
    "PI": "Piauí",
    "RJ": "Rio de Janeiro",
    "RN": "Rio Grande do Norte",
    "RS": "Rio Grande do Sul",
    "RO": "Rondônia",   
    "RR": "Roraima",
    "SC": "Santa Catarina",
    "SP": "São Paulo",
    "SE": "Sergipe",
    "TO": "Tocantins"
};  



export const MidiasContato = {
    "sms": "SMS",
    "email": "E-mail",
    "whatsapp": "Whatsapp",
    "telefone": "Telefone",
    "streaming": "Streaming",
    "manuseio": "Manuseio"
};

export const areasEmailLog = {
    "atendimento_etapa": "Atendimento / Etapa",
    "regua_comunicacao": "Régua de Comunicação",
    "programa_regra": "Regra do Programa",
    "farmacovigilancia_pdf": "Farmacovigilância PDF",
    "exame": "Exame",
    "termos": "Termo do paciente",
    "termos_prestador": "Termo do profissional",
    "agendamento_solicitacao_prestador": "Agendamento / Solicitação ao prestador",
    "agendamento_atualizacao": "Agendamento / Atualização",
    "agendamento_link_paciente": "Agendamento / Link do paciente",
    //"atendimentos_relatos": "Relatos de Atendimento",
};

export const tiposMensagem = {
    "padrao": "Padrão",
    "retorno": "Retorno",
    "cancelamento": "Cancelamento",
};

export const MidiasAceita = {
    "email": "E-mail",
    "whatsapp": "Whatsapp",
    "telefone": "Telefone"
};

export const unidadesDosagens = {
    "unidade": "Unidade",
    "ml": "ml",
    "g": "g",
    "mg": "mg",
}

// O backend grava 1900-01-01 quando a data não foi informada; não faz sentido exibir isso.
export const isDataNaoInformada = (data) => !data || String(data).startsWith('1900-01-01');

// A data chega do backend sem fuso e é exibida como está: o 'Z' acrescentado e o timeZone
// UTC evitam que o navegador a converta. O formato segue o idioma ativo — 05/08/2026 em
// pt-BR e es, 08/05/2026 em en-US.
const FORMATO_DATA_EXIBICAO = { timeZone: 'UTC', day: '2-digit', month: '2-digit', year: 'numeric' };

export const formataDataExibicao = (data) => {
    if(isDataNaoInformada(data)){
        return '';
    }

    const data_obj = new Date(data + 'Z');

    if (isNaN(data_obj.getTime())) {
        return '';
    }

    return data_obj.toLocaleDateString(idiomaAtual(), FORMATO_DATA_EXIBICAO);
}

// Resposta de formulario de etapa no idioma de quem le. O formulario grava "sim"/"nao" no checkbox,
// "True"/"False" no voltar etapa e data em ISO; o rotulo traduzido das opcoes vem pronto do backend
// (valor_exibicao). Texto digitado pelo usuario sai como foi escrito.
const RESPOSTAS_SIM = ['sim', 'true'];
const RESPOSTAS_NAO = ['nao', 'não', 'false'];

export const formataRespostaRelato = (valor, tipo, valorExibicao) => {
    if (valorExibicao !== null && valorExibicao !== undefined && valorExibicao !== '') {
        return valorExibicao;
    }

    if (typeof valor !== 'string' || !valor || tipo === 'texto' || tipo === 'area_texto') {
        return valor;
    }

    const texto = valor.trim();
    const minusculo = texto.toLowerCase();

    if (RESPOSTAS_SIM.includes(minusculo)) return i18n.t('common:label.yes');
    if (RESPOSTAS_NAO.includes(minusculo)) return i18n.t('common:label.no');
    if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) return formataDataExibicao(texto);

    return valor;
}

// Formata valores crus vindos da API (relatorios dinamicos, por exemplo) para exibicao.
// Datas e datas/hora em ISO viram o formato pt-BR; qualquer outro valor volta inalterado.
export const formataValorExibicao = (valor) => {
    if (typeof valor !== 'string' || !valor) {
        return valor;
    }

    const somenteData = /^\d{4}-\d{2}-\d{2}$/;
    const dataHora = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2})?(\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/;

    if (somenteData.test(valor)) {
        return formataDataExibicao(valor + 'T00:00:00');
    }

    if (dataHora.test(valor)) {
        return formataDataHoraExibicao(valor);
    }

    return valor;
}

export function getDataAtualLocalISO() {
    const agora = new Date();
    const offset = agora.getTimezoneOffset() * 60000; // diferença do fuso em milissegundos
    const localISOTime = new Date(agora - offset).toISOString().slice(0, 16);
    return localISOTime;
}

/*export const formataDataHoraExibicao = (data) => {
    if(!data){
        return '';
    }

    const data_obj = new Date(data);
    const dataFormatada = data_obj.toLocaleString("pt-BR", { timeZone: 'UTC' });
    
    return dataFormatada.slice(0, 17) + 'h';
}*/

export const formataDataHoraExibicao = (data) => {
    if (isDataNaoInformada(data)) {
        return '';
    }

    // O backend grava datetime naive (USE_TZ=False), entao o valor recebido nao deve sofrer
    // conversao de fuso: interpretamos como UTC e formatamos em UTC. Valores que ja trazem
    // fuso ('...Z', '+00:00' ou um objeto Date) nao podem receber outro 'Z' - isso gerava
    // "Invalid Date"; nesse caso converte-se para o fuso de Sao Paulo.
    const valor = typeof data === 'string' ? data.trim() : data;
    const temFuso = !(typeof valor === 'string') || /(Z|[+-]\d{2}:?\d{2})$/.test(valor);
    const data_obj = temFuso ? new Date(valor) : new Date(valor + 'Z');

    // data que o navegador não consegue interpretar (ex.: já vinha com fuso, virando '...ZZ')
    // aparecia na tela como "Invalid Dateh" -- melhor não mostrar nada
    if (isNaN(data_obj.getTime())) {
        return '';
    }

    // Formata no idioma ativo. Data sem fuso fica em UTC para não sofrer conversão; quando o
    // valor já traz fuso, converte para São Paulo (mesma regra de `temFuso` acima).
    const idioma = idiomaAtual();
    const fuso = temFuso ? 'America/Sao_Paulo' : 'UTC';
    const dataParte = data_obj.toLocaleDateString(idioma, { ...FORMATO_DATA_EXIBICAO, timeZone: fuso });
    const horaParte = data_obj.toLocaleTimeString(idioma, { timeZone: fuso, hour: '2-digit', minute: '2-digit' });

    // O sufixo 'h' é convenção brasileira ("05/08/2026, 14:30h"); nos outros idiomas fica
    // só a hora no formato local ("08/05/2026, 02:30 PM" em en-US).
    return `${dataParte}, ${horaParte}${idioma === 'pt-BR' ? 'h' : ''}`;
}

// Mapeia o status de envio de e-mail para uma variante de Badge do Bootstrap.
// Retorna { bg, text } pronto para uso em <Badge bg={bg} text={text}>.
export const statusEmailBadge = (status) => {
    const s = String(status || '').toLowerCase().trim();
    let bg = 'secondary';

    if (s) {
        if (/(entregue|delivered|confirmad|sucesso|success)/.test(s)) {
            bg = 'success';
        } else if (/(bounce|devolv|falha|erro|error|rejeit|reject|reclam|complaint|spam|fail)/.test(s)) {
            bg = 'danger';
        } else if (/(pendente|pending|aguard|process|deferr|deferid|adiad|fila|queued)/.test(s)) {
            bg = 'warning';
        } else if (/(enviado|sent|aberto|open|clic|click)/.test(s)) {
            bg = 'info';
        }
    }

    const text = ['warning', 'info', 'light'].includes(bg) ? 'dark' : undefined;

    return { bg, text };
};

export const formataDataApi = (data) => {
    if(!data){
        return '';
    }

    data = data.slice(0, 10)

    let parts = data.split('/');    
    let data_obj = new Date(parts[2], parts[1] - 1, parts[0]);     
    
    return data_obj.toISOString().slice(0, 10);
}  

export function getDataAtual() {
    const agora = new Date();
    const opcoes = { timeZone: 'America/Sao_Paulo', hour12: false };
    const dataHoraSaoPaulo = agora.toLocaleString('pt-BR', opcoes).replace(/\//g, '-').replace(',', '');

    // Formatar a data para YYYY-MM-DD HH:MM:SS
    const dataFormatada = dataHoraSaoPaulo.split(' ')[0].split('-').reverse().join('-');
    const horaFormatada = dataHoraSaoPaulo.split(' ')[1];
    const dataHoraAtualFormatada = `${dataFormatada} ${horaFormatada}`;

    return dataHoraAtualFormatada;
}

export function getDataAtualSemSegundos() {
    const agora = new Date();
    const opcoes = {
        timeZone: 'America/Sao_Paulo',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit'
    };
    const dataHoraSaoPaulo = agora.toLocaleString('pt-BR', opcoes).replace(/\//g, '-').replace(',', '');

    // Formatar a data para YYYY-MM-DD HH:MM
    const dataFormatada = dataHoraSaoPaulo.split(' ')[0].split('-').reverse().join('-');
    const horaFormatada = dataHoraSaoPaulo.split(' ')[1];
    const dataHoraAtualFormatada = `${dataFormatada} ${horaFormatada}`;

    return dataHoraAtualFormatada;
}

export function extrairDataDatetime(data_time) {
    if(!data_time){
        return ''
    }

    const data = data_time.split('T')[0];
    return data;
}

export function formataCNPJ(numero) {
    if(!numero){
        return ''
    }

    numero = numero.replace(/\D/g, '');

    if (numero.length === 11) {
        return numero.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (numero.length === 14) {
        return numero.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    } else {
        return numero;
    }
}

export function validaSenha(senha) {
    const regex = {
        comprimento: /.{8,}/, // verifica se tem pelo menos 8 caracteres
        maiuscula: /[A-Z]/,   // verifica se tem pelo menos uma letra maiúscula
        minuscula: /[a-z]/,   // verifica se tem pelo menos uma letra minúscula
        numero: /[0-9]/,      // verifica se tem pelo menos um número
        especial: /[^A-Za-z0-9]/ // verifica se tem pelo menos um caractere especial
    };

    return regex.comprimento.test(senha) &&
           regex.maiuscula.test(senha) &&
           regex.minuscula.test(senha) &&
           regex.numero.test(senha) &&
           regex.especial.test(senha);
}

export function formataCPF(numero) {
    if(!numero) return '';

    //CPF mascarado (dado bloqueado para a categoria do prestador) sai como veio da API
    if (typeof numero === 'string' && numero.includes('*')) return numero;
    numero = numero.replace(/\D/g, '');

    if (numero.length === 11) {
        return numero.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
        return numero;
    }
}

/**
 * Grupos de dados do paciente bloqueados para o usuário logado (termo, contato, nome, cpf, endereco).
 * A API informa na própria resposta, em `visibilidade_paciente.bloqueados`.
 */
export function gruposPacienteBloqueados(dados) {
    return dados?.visibilidade_paciente?.bloqueados || [];
}

export function dadoPacienteBloqueado(dados, grupo) {
    return gruposPacienteBloqueados(dados).includes(grupo);
}

/** O PDF do termo traz nome, CPF e endereço impressos: qualquer um deles bloqueado esconde o documento. */
export function pdfTermoBloqueado(dados) {
    return ['termo', 'nome', 'cpf', 'endereco'].some((grupo) => dadoPacienteBloqueado(dados, grupo));
}

/** Campos do cadastro do paciente por grupo de visibilidade (espelha o mapa do backend). */
const CAMPOS_PACIENTE_POR_GRUPO = {
    nome: ['nome', 'nome_mae', 'cuidador_nome'],
    cpf: ['cpf', 'cuidador_cpf', 'rg', 'matricula', 'numero_carteirinha'],
    contato: ['email', 'telefone', 'celular', 'endereco_telefone', 'cuidador_celular', 'cuidador_telefone', 'cuidador_email'],
    endereco: ['cep', 'endereco', 'numero', 'complemento', 'bairro', 'nome_local', 'referencia', 'cuidador_endereco'],
};

/**
 * Tira do formulário os campos que o usuário não pode ver: o valor que ele tem em tela é a máscara,
 * e reenviá-lo sobrescreveria o dado real. O backend também ignora esses campos.
 */
export function removerCamposBloqueadosDoFormData(formData, visibilidade) {
    const bloqueados = visibilidade?.bloqueados || [];

    bloqueados.forEach((grupo) => (CAMPOS_PACIENTE_POR_GRUPO[grupo] || []).forEach((campo) => formData.delete(campo)));

    return formData;
}

export function validaCPF(cpf) {
    if (!cpf) return false;

    // Remove caracteres não numéricos
    cpf = cpf.replace(/[^\d]+/g, '');

    // Verifica se tem 11 dígitos
    if (cpf.length !== 11) return false;

    // Verifica se todos os dígitos são iguais (ex.: 111.111.111-11)
    if (/^(\d)\1+$/.test(cpf)) return false;

    // Validação do primeiro dígito verificador
    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    // Validação do segundo dígito verificador
    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;

    return true;
}

export function formatarValorAPISemDecimais(valor) {
    valor = valor.split('.');
    return valor[0];
}


export function formatarValorAPI(raw) {
    if (raw == null || raw === '') return 0;
    const s = String(raw).replace(/[^\d.,-]/g, '');
    const sep = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    const nStr = sep > -1
      ? s.slice(0, sep).replace(/[.,]/g, '') + '.' + s.slice(sep + 1)
      : s;
    const n = parseFloat(nStr);
    return isNaN(n) ? '0' : n.toString();
}

// Obrigatórios da despesa de agendamento. Origem, destino e km total só entram
// na regra quando o usuário marca "Informar km" (ou escolhe Quilometragem).
export function validaDespesaAgendamento(form) {
    const f = form || {};
    const faltando = [];

    const categoriaOutros =
        (f.despesa_categoria_slug || '').toLowerCase() === 'outros' ||
        (f.despesa_categoria_nome || '').toLowerCase() === 'outros' ||
        String(f.despesa_categoria_id) === '__outros__';

    // rótulos no idioma do usuário; o padrão cobre a tela que não carregou o namespace
    const rotulo = (campo, padrao) => i18n.t(`agendamentos:agendas.expenses.form.${campo}`, { defaultValue: padrao });

    if (!String(f.descricao || '').trim()) faltando.push(rotulo('description', 'Descrição'));
    if (!parseFloat(formatarValorAPI(f.valor))) faltando.push(rotulo('value', 'Valor'));
    if (!f.data) faltando.push(rotulo('date', 'Data'));

    if (categoriaOutros) {
        if (!String(f.categoria_outros || '').trim()) faltando.push(rotulo('describeOthers', 'Descrever (Outros)'));
    } else if (!f.despesa_categoria_id) {
        faltando.push(rotulo('category', 'Categoria'));
    }

    if (!f.comprovanteFile) faltando.push(rotulo('receipt', 'Comprovante'));

    if (f.informar_km) {
        if (!String(f.endereco_origem || '').trim()) faltando.push(rotulo('origin', 'Endereço de origem'));
        if (!String(f.endereco_destino || '').trim()) faltando.push(rotulo('destination', 'Endereço de destino'));

        const km = parseFloat(String(f.km_total || '').replace(/\./g, '').replace(',', '.'));
        if (!km) faltando.push(rotulo('kmTotal', 'Km total'));
    }

    return faltando;
}
  

export function formatarValor(valor) {
    // Remove tudo que não é número
    if(!valor) return '';
    // Convert to string if valor is a number
    if (typeof valor === 'number') {
        valor = valor.toString();
    }
    let valorNumerico = valor.replace(/\D/g, "");

    // Garante que o valor tenha pelo menos 3 dígitos, preenchendo com zeros à esquerda se necessário
    valorNumerico = valorNumerico.padStart(3, '0');

    // Formata os dois últimos dígitos como centavos
    valorNumerico = valorNumerico.slice(0, -2) + "," + valorNumerico.slice(-2);

    // Adiciona os separadores de milhar
    valorNumerico = valorNumerico.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Remove o zero à esquerda se o número é menor que 10
    if (valorNumerico.startsWith("0") && valorNumerico.charAt(1) !== ',') {
        valorNumerico = valorNumerico.substring(1);
    }

    return valorNumerico;
}

export function formatarValorLocal(valor) {
    return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export const mascaras_disponiveis = [
    'prefill[data_atual]',
    'prefill[pais-brasil]',

    //dadosUsuarios
    'prefill[email_usuario]',
    'prefill[pessoa_preencheu]',

    'prefill[nome_medicamento]',
    
    // extra_valores_list
    'prefill[data_inicio_terapia]',
    'prefill[dose]',
    'prefill[freq_aplicacao]', 
    'prefill[apresentacao]',

    //dados_medicos 
    'prefill[medico_prescritor]', 
    'prefill[medico_registro]', 
    'prefill[medico_registro_uf]', 

    // dados_programa
    'prefill[telefone_formulario]',

    // dados_beneficiario
    'prefill[nome_paciente]',
    'prefill[data_nascimento]',
    'prefill[sexo_beneficiario]',
    'prefill[peso_beneficiario]',
    'prefill[altura_beneficiario]',

    // exibe imagem abaixo do campo (informe o caminho da imagem entre colchetes)
    'imagem-auxiliar[...]',
];

export const tiposCampos = {
    texto: "Texto",
    numero: "Número",
    area_texto: "Área de Texto",
    selecao: "Seleção",
    checkbox: "Checkbox",
    radio: "Radio",
    data: "Data",
    arquivo: "Arquivo",
    repeater: "Repetidor",
    gotoconnect: "GoTo Connect",
    hiplatform: "HiPlatform",
    voltar_etapa: "Voltar Etapa",
    cancela_atendimento: "Cancela Atendimento",
    motivo_cancelamento: "Motivo Cancelamento",
    informacao: "Informação",
};

export const tiposRepeater = {
    texto: "Texto",
    numero: "Número",
    area_texto: "Área de Texto",
    selecao: "Seleção",
    checkbox: "Checkbox",
    radio: "Radio",
    data: "Data",
    arquivo: "Arquivo",
    gotoconnect: "GoTo Connect",
    voltar_etapa: "Voltar Etapa",
    cancela_atendimento: "Cancela Atendimento",
    motivo_cancelamento: "Motivo Cancelamento",
    informacao: "Informação",
};


export const tiposMidias = {
    "SMS" : "SMS",
    "E-mail" : "E-mail",
    "Whatsapp" : "Whatsapp",
    "Telefone" : "Telefone",
    "Streaming" : "Streaming"
};

export const destinatariosMensagem = {
    medico: "Médico",
    laboratorio: "Laboratório",
    paciente: "Paciente",
};

export const origemReceptivo = {
    medico: "Médico",
    laboratorio: "Laboratório",
    paciente: "Paciente",
    responsavel: "Responsável legal/Cuidador",
    outro: "Outro"
};

export const statusAtendimento = {
    em_andamento: "Em Andamento",
    aguardando: "Aguardando",
    concluido: "Concluído",
    parado: "Parado",
    cancelado: "Cancelado",
};

export const tiposCancelamento = {
    somente_etapa: "Cancelar Somente Etapa",
    definitivo: "Cancelar Atendimento em Definitivo",
};

export const papeisAssinatura = {
    "Paciente": "Paciente",
    "Médico": "Médico",
    "Laboratório": "Laboratório",
};

export const responsaveisEtapas = {
    //cliente: "Cliente",
    "operador": "Operador Aditus",
    //gestor: "Gestor",
    //beneficiario: "Beneficiário",
    "medicos": "Médico",
    "assessor_tecnico": "Assessor Técnico",
    "multiprofissionais": "Multiprofissional",
    //farmacias: "Farmácia",
    "hospitais": "Hospital",
    "clinicas": "Clínica",
    "laboratorio_diagnostico": "Laboratório de Diagnósticos",
    "cooperativas_saude": "Cooperativa de Saúde",
    "motoristas": "Transporte",
    "logistica": "Logística",
    "servicos_diagnostico": "Serviços Diagnóstico",
    //fornecedor: "Fornecedor",
};

export const tiposUsuarioBotoes = {
    //cliente: "Cliente",
    "operador": "Operador Aditus",
    //gestor: "Gestor",
    //beneficiario: "Beneficiário",
    "medicos": "Médico",
    "assessor_tecnico": "Assessor Técnico",
    "multiprofissionais": "Multiprofissional",
    //farmacias: "Farmácia",
    //hospitais: "Hospital",
    //clinicas: "Clínica",
    "laboratorio_diagnostico": "Laboratório de Diagnósticos",
    "cooperativas_saude": "Cooperativa de Saúde",
    "motoristas": "Transporte",
    "logistica": "Logística",
    //fornecedor: "Fornecedor",
};

export const tiposEnvio = {
    automatico: "Automático",
    manual: "Manual",        
    ambos: "Ambos",
};

export const momentosEnvio = {
    inicio: "Início",
    termino: "Termino",  
};

export const statusAprovacao = {
    pendente: "Pendente",
    aprovado: "Aprovado",        
    negado: "Negado",
};

export const statusChamados = {
    novo: "Novo",
    andamento: "Em Andamento",
    validacao: "Aguardando Validação",
    concluido: "Concluido",
    cancelado: "Cancelado"
}

export const prioridadeChamados = {
    1: "Alta",
    2: "Média",
    3: "Baixa"
}

export const tiposChamados = {
    "suporte_tecnico": "Suporte Técnico",
    "solicitacao_acesso": "Solicitação de Acesso",
    "erro_integracao": "Erro de Integração",
    "ajuste_cadastro": "Ajuste de Cadastro",
    "duvida_operacional": "Dúvida Operacional",
    "melhoria_evolutiva": "Melhoria / Evolutiva",
    "incidente_critico": "Incidente Crítico"
};

export const descricoesTipos = {
    "suporte_tecnico": "Problemas relacionados ao funcionamento do sistema.",
    "solicitacao_acesso": "Criação, alteração ou exclusão de usuários.",
    "erro_integracao": "Falhas na comunicação entre o CRM e outros sistemas.",
    "ajuste_cadastro": "Correção de informações incorretas em cadastros.",
    "duvida_operacional": "Orientações sobre o uso das funcionalidades.",
    "melhoria_evolutiva": "Pedidos de novas funcionalidades ou ajustes de processo.",
    "incidente_critico": "Falhas graves que impactam o uso global da plataforma."
};

export const categoriasDeProgramas = {
    industria_farmaceutica: "Indústria Farmacêutica",
    plano_saude: "Plano de Saúde",
    governo: "Governo",
    empresa: "Empresa",
    pessoa_fisica: "Pessoa Física"
};

export const tipoUsuarioDashboard = {
    gestor: "Gestor",
    navegador: "Navegador",
    medico: "Médico",
    profissional: "Profissional",
};

export const situacoesAgendamento = {
    solicitado: "Solicitado",
    liberado: "Liberado",
    em_analise: "Em análise",
    finalizado: "Finalizado",
    cancelado: "Cancelado",
    arquivo_pendente: "Arquivo Pendente"
};

export const tiposArquivos = {
    pedido_medico: "Pedido Médico",
    termo: "Termo de Consentimento",
    laudo: "Laudo",
    laudo_evidencia: "Arquivo Evidência",
    exame: "Exame",
    nfe: "NFE",
    comprovante: "Comprovante",
    formulario: "Formulário",
    monitoramento: "Arquivo de Monitoramento",
    // já existiam no backend, mas ficavam sem rótulo na tela
    relatorio_consultoria: "Relatório de Consultoria",
    evidencia_liberacao: "Evidência de Liberação"
};

export const coberturasTratamento = {
    sus: "SUS",
    saude_suplementar: "Saúde Suplementar",
    sus_saude_suplementar: "SUS e Saúde Suplementar",
    out_of_pocket: "Out of Pocket"
};

export const tiposServicos = {
    servico: "Serviço",
    procedimento: "Procedimento"
};

export const regrasPlanos = {
    produtos: "Produto",
    servicos_procedimentos: "Serviço/Procedimento"
};

export const tiposPaciente = {
    interno: "Interno",
    externo: "Externo",
};

export const statusExamesSelecionados = {
    busca_local: "Em busca de local para realização",
    aguardando_paciente: "Aguardando retorno do paciente",
    aguardando_laboratorio: "Aguardando retorno do laboratório/clínica",
    aguardando_aprovacao: "Aguardando aprovação",
    em_analise: "Em análise",
    pendente: "Pendente",
    aprovado: "Aprovado",
    agendado: "Agendado",
    reagendado: "Reagendado",
    realizado: "Realizado",
    cancelado: "Cancelado",
    recusado: "Recusado",
    recusado_elegibilidade: "Recusado - Elegibilidade",
    stand_by: "Stand By",
    fora_pcdt: "Fora do PCDT"
}

export const statusExame = {
    recusado: "Recusado",
    andamento_pendente_aprovacao: "Andamento - pendente aprovação",
    andamento_aguardando_retorno_paciente: "Andamento - aguardando retorno o paciente",
    andamento_aguardando_retorno_local: "Andamento - aguardando retorno do local",
    em_busca_de_local_para_realizacao: "Em busca de local para realização",
    em_analise: "Em análise",
    pendente: "Pendente",
    agendado: "Agendado",
    realizado: "Realizado",
    realizado_parcial: "Realizado parcial (pendente exames)",
    cancelado: "Cancelado",
    fora_pcdt: "Fora do PCDT",
    stand_by: "Stand By",
}

export const hasPerm = (permission) => {
    const globalValue = JSON.parse(localStorage.getItem('globalContextValue'));
    const userPermissions = globalValue?.user?.permissions || [];

    if(globalValue?.user?.is_superuser){
        return true;
    }

    if(userPermissions.includes(permission)){
        return true;
    }

    return false;
}

export const encryptData = (name, data, storageType = 'cookie') => {
    try {
        const stringifiedData = JSON.stringify(data);
        const encrypted = CryptoJS.AES.encrypt(stringifiedData, SECRET_KEY).toString();

        if (storageType === 'localStorage') {
            localStorage.setItem(name, encrypted);
        } else { // Padrão é cookie
            if (name === 'p') {
                if (encrypted.length > 4000) {
                     console.warn(`<<< [encryptData name='${name}'] WARNING: Size (${encrypted.length}) exceeds typical cookie limits.`);
                }
            }
            Cookies.set(name, encrypted, { secure: true, sameSite: 'Strict', path: '/', expires: 1 });
        }
    } catch (error) {
         console.error(`<<< [encryptData name='${name}'] CRITICAL ERROR during encryption or saving:`, error);
    }
};

export const decryptData = (name, storageType = 'cookie') => {
    let encrypted = null;
    if (storageType === 'localStorage') {
        encrypted = localStorage.getItem(name);
    } else { // Padrão é cookie
        encrypted = Cookies.get(name);
    }


    if (encrypted) {
        try {
            const decryptedBytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
            const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);

            if (!decryptedString) {
                if (name === 'p') return [];
                return null;
            }

            const parsedData = JSON.parse(decryptedString);
            return parsedData;

        } catch (error) {
             console.error(`<<< [decryptData name='${name}'] CRITICAL ERROR during decryption/parsing:`, error);
             if (name === 'p') return [];
             return null;
        }
    }

    if (name === 'p') {
        return [];
    }
    return null;
};

export const getCurrentUser = () => {
    const user = Cookies.get('user');
    const decryptedData = decryptData('o');
    const restricoes = decryptData('r');
    const permissions = decryptData('p', 'localStorage');
    const prog = decryptData('prog');

    if (user && decryptedData) {
        const parsedUser = JSON.parse(user);
        return {
            ...parsedUser,
            ...decryptedData,
            ...prog,
            restricoes: restricoes || [],
            permissions: Array.isArray(permissions) ? permissions : [],
        };
    }
    return null;
};
export const logout = () => {
    TokenService.removeUser();
};

//prestador marcado no cadastro para nao ver a gestao financeira (ocultar_faturamento vem nas restricoes do login)
export const prestadorOcultaFaturamento = (usuario = getCurrentUser()) => {
    if (!usuario?.prestador_id) return false;
    return (usuario.restricoes || []).some(
        (r) => String(r.prestador_id) === String(usuario.prestador_id) && r.ocultar_faturamento === true
    );
};

const lista_restricoes_map = {
    "cliente": "Cliente",
    "operador": "Operador",
    "gestor": "Gestor",
    "beneficiario": "Beneficiário",
    "prestador": "Prestador",
    "fornecedor": "Fornecedor",
    "administrador": "Administrador",
};

export const TIPOS_USUARIOS_LISTA = Object.keys(lista_restricoes_map).map(slug => ({
    value: slug,
    label: lista_restricoes_map[slug]
}));

export const tiposAcesso = () => {
    // Descriptografa as restrições do cookie 'r'
    const lista_restricoes_usuario = decryptData('r');

    if (lista_restricoes_usuario) {
        let arr_nova = {};
        for (let i = 0; i < lista_restricoes_usuario.length; i++) {
            let tipo_usuario = lista_restricoes_usuario[i]['tipo_usuario'];
            let operador_id = lista_restricoes_usuario[i]['operador_id'];
            let prestador_id = lista_restricoes_usuario[i]['prestador_id'];
            let gestor_id = lista_restricoes_usuario[i]['gestor_id'];
            let beneficiario_id = lista_restricoes_usuario[i]['beneficiario_id'];
            let tipo_gestor = lista_restricoes_usuario[i]['tipo_gestor'];

            arr_nova[tipo_usuario] = {
                label: lista_restricoes_map[tipo_usuario],
                operador_id: operador_id,
                prestador_id: prestador_id,
                gestor_id: gestor_id,
                beneficiario_id: beneficiario_id,
                tipo_gestor: tipo_gestor,
            };
        }

        return arr_nova;
    }

    return [];
};

export function executeFunctionByName(functionName, context /*, args */) {
    var args = Array.prototype.slice.call(arguments, 2);
    var namespaces = functionName.split(".");
    var func = namespaces.pop();
    for(var i = 0; i < namespaces.length; i++) {
      context = context[namespaces[i]];
    }
    return context[func].apply(context, args);
}

export const localUso = {
    "home_office": "Home Office",
    "escritorio": "Escritório",
    "ambos": "Ambos",
};

export const prestadoresCategorias = {
    "medicos": "Médicos",
    "assessor_tecnico": "Assessor Técnico",
    "multiprofissionais": "Multiprofissionais",
    "farmacias": "Farmácias",
    "hospitais": "Hospitais",
    "clinicas": "Clínicas",
    "plataformas": "Plataformas",
    "laboratorio_diagnostico": "Laboratórios de Diagnósticos",
    "cooperativas_saude": "Cooperativas de Saúde",
    "motoristas": "Transporte",
    "logistica": "Logística",
    "servicos_diagnostico": "Serviços Diagnóstico"
};

export const tiposSessoesCampos = {
    "0_sem_sessao": "",
    "geral": "Dados gerais",
    "informacoes_relator": "Dados do relator",
    "dados_paciente": "Dados do paciente",
    "medico_prescricao": "Médico prescritor",
    "medico_tratamento": "Médico do tratamento",
    "informacoes_medicamento_suspeito": "Medicamento suspeito",
    "inf_evento_adverso_evento1": "Evento adverso 1",
    "inf_evento_adverso_evento2": "Evento adverso 2",
    "inf_evento_adverso_evento3": "Evento adverso 3",
    "outras_inf_relevantes": "Informações relevantes",
    "queixa_sobre_produto": "Queixa sobre o produto"
}

export const categoriasDeDicas = {
    medicos: "Médico",
    assessor_tecnico: "Assessor Técnico",
    multiprofissionais: "Multiprofissional",
    farmacias: "Farmácia",
    hospitais: "Hospital",
    clinicas: "Clínica",
    plataforma: "Plataforma",
    serviço_diagnostico: "Serviços Diagnósticos",
    laboratorio_diagnostico: "Laboratório de Diagnósticos",
    cooperativas_saude: "Cooperativas de Saúde",
    outros: "Outros",
};

export const categoriasDeGraficos = {
    atendimentos_medicos_mes: "Atendimentos agrupados pelo nome do médico no mês atual",
    atendimentos_ano: "Atendimentos agrupados por ano do ano atual",    
    atendimentos_laboratorios_mes: "Atendimentos agrupados pelo nome do laboratório no mês atual",   
    atendimentos_cidades_mes: "Atendimentos agrupados por cidade e estado dentro do mês",
};

export const tiposGestores = {
    interno: "Interno",
    industria: "Indústria",
}

export const objMeses = {
    1: 'Jan',
    2: 'Fev',
    3: 'Mar',
    4: 'Abr',
    5: 'Mai',
    6: 'Jun',
    7: 'Jul',
    8: 'Ago',
    9: 'Set',
    10: 'Out',
    11: 'Nov',
    12: 'Dez'
}

export const aprovacaoNota = {
    analise: "Análise",
    aprovado: "Aprovado",
    recusado: "Recusado",
}

export const modelosDeMensagem = {
    faturamento_aviso_laboratorio:"Faturamento Aviso Laboratório",
    faturamento_aviso_notafiscal: "Faturamento Aviso Nota Fiscal",
    faturamento_aviso_pagamento: "Faturamento Aviso Pagamento",
    faturamento_aviso_nota_recusada: "Faturamento Aviso Nota Fiscal Recusada",
    importacao_medico: "Importação de Médicos"
}

export const tiposSessoesAtendExtra = {
    "0_sem_sessao": "",
    "geral": "Dados gerais",    
    "detalhes_paciente": "Detalhes Paciente",    
    "tratamento": "Tratamento",    
    "detalhes_prescricao": "Detalhes Prescrição",    
    "observacoes": "Observações",    
    "termos": "Termos",    
    "laudo": "Laudo",    
    "detalhes_acesso": "Detalhes Acesso",    
    "acompanhamento": "Acompanhamento",    
}

export const tratarNulos = (obj) => {
    const novoObjeto = {};
    for (let key in obj) {
        novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
    }
    return novoObjeto;
};

export const calcularTempoNaEtapa = (dataCadastro) => {
    // Converter data de entrada para o fuso horário de São Paulo
    const dataCadastroLocal = new Date(
        new Date(dataCadastro).toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
    );

    // Obter a data e hora atual no fuso horário de São Paulo
    const agoraLocal = new Date(
        new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
    );

    // Calcular diferenças detalhadas
    const minutosTotais = differenceInMinutes(agoraLocal, dataCadastroLocal);
    const dias = Math.floor(minutosTotais / (60 * 24));
    const horas = Math.floor((minutosTotais % (60 * 24)) / 60);
    const minutos = minutosTotais % 60;

    if (minutosTotais < 1) {
        return i18n.t('common:duration.lessThanOneMinute');
    }

    let resultado = [];

    // Adicionar dias, horas e minutos dinamicamente (o plural vem do i18next)
    if (dias > 0) {
        resultado.push(i18n.t('common:duration.days', { count: dias }));
    }
    if (horas > 0) {
        resultado.push(i18n.t('common:duration.hours', { count: horas }));
    }
    if (minutos > 0) {
        resultado.push(i18n.t('common:duration.minutes', { count: minutos }));
    }

    // Une as partes como o idioma une listas: "1 dia, 2 horas e 3 minutos" em pt-BR,
    // "1 day, 2 hours, and 3 minutes" em en-US
    return new Intl.ListFormat(idiomaAtual(), { style: 'long', type: 'conjunction' }).format(resultado);
};

export const isUUID = (str) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
};
export const formatDateBRtoUS = (data) => {
    if(!data) return '';
    let new_date = data.split("/");
    return new_date[2] + '-' + new_date[1] + '-' + new_date[0];
}

export const formatDateUStoBR = (data) => {
    if(!data) return '';
    let new_date = data.split('T')[0];
    new_date = new_date.split("-");
    return new_date[2] + '/' + new_date[1] + '/' + new_date[0];
}

export const getHour  = (data) => {
    if(!data) return '';
    let new_date = data.split('T')[1];
    new_date = new_date.split(":");
    return new_date[0] + ':' + new_date[1];
}

export function generateUniqueColor(input) {
    // Cria um hash único para a string
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Converte o hash em valores RGB
  let r = (hash >> 16) & 0xFF;
  let g = (hash >> 8) & 0xFF;
  let b = hash & 0xFF;

  // Calcula a luminosidade relativa (0-255)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // Se a cor for muito clara, escurece; se for muito escura, clareia
  if (brightness > 200) {
    r = Math.floor(r * 0.8); // Escurece
    g = Math.floor(g * 0.8);
    b = Math.floor(b * 0.8);
  } else if (brightness < 50) {
    r = Math.min(255, Math.floor(r * 1.2)); // Clareia
    g = Math.min(255, Math.floor(g * 1.2));
    b = Math.min(255, Math.floor(b * 1.2));
  }

  // Retorna a cor no formato hexadecimal
  return `rgb(${r}, ${g}, ${b})`;
}
  
export function grupoEtario(dataNascimento) {
    if (!dataNascimento) return '';

    const dataNascimentoObj = new Date(dataNascimento);
    const dataAtual = new Date();

    let idade = dataAtual.getFullYear() - dataNascimentoObj.getFullYear();
    const mes = dataAtual.getMonth() - dataNascimentoObj.getMonth();

    if (mes < 0 || (mes === 0 && dataAtual.getDate() < dataNascimentoObj.getDate())) {
        idade--;
    }

    if (idade >= 0 && idade <= 12) {
        return 'Criança';
    } else if (idade >= 13 && idade <= 17) {
        return 'Adolescente';
    } else if (idade >= 18) {
        return 'Adulto';
    }

    return '';
}

export function isDataFutura(dataBr) {
    if (!dataBr) return false;

    // Separar data e hora
    const [data, hora] = dataBr.split(', '); // "21/06/2025, 08:10"

    // Converter para ISO
    const dataISO = formatDateBRtoUS(data); // "2025-06-21"

    const dataCompletaISO = `${dataISO}T${hora}:00`; // "2025-06-21T08:10:00"

    const dataInformada = new Date(dataCompletaISO);
    const agora = new Date();

    return dataInformada > agora;
}

export function mensagemAlerta(mensagem, tipo = 'warning') {
    const MySwal = withReactContent(Swal);
    switch (tipo) {
        case 'warning':
            MySwal.fire({
                icon: tipo,
                title: 'Atenção!',
                text: mensagem,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            break;
        case 'error':
            MySwal.fire({
                icon: tipo,
                title: 'Erro!',
                text: mensagem,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            break;
        case 'success':
            MySwal.fire({
                icon: tipo,
                title: 'Sucesso!',
                text: mensagem,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            break;
    }
}

// valida URL
export function isValidUrl(value) {
  try {
    // a URL lança se não for válida
    new URL(value);
    return true;
  } catch {
    return false;
  }
}

export const motivosAplicacao = {
    // "Farmacovigilância": "Farmacovigilância",
    // "Falta de medicação": "Falta de medicação",    
    // "Fatores independentes": "Fatores independentes",
    // "Falta de medicação": "Falta de medicação",
    "Sem medicação - Falta na farmácia": "Sem medicação - Falta na farmácia",
    "Sem medicação - Logística do paciente  ": "Sem medicação - Logística do paciente",
    "Sem medicação - Pendente atualização de documentação  ": "Sem medicação - Pendente atualização de documentação  ",
    "Decisão do paciente": "Decisão do paciente",
    "Farmacovigilância (Saúde do paciente)": "Farmacovigilância (Saúde do paciente)",
    "Problemas de acesso administrativo/paciente no local de infusão": "Problemas de acesso administrativo/paciente no local de infusão",
    "Decisão do profissional de saúde": "Decisão do profissional de saúde",
    "Falta de aprovação regulatória": "Falta de aprovação regulatória",
    "Relacionado ao pagador": "Relacionado ao pagador",
    "Treinamento/disponibilidade da equipe de infusão": "Treinamento/disponibilidade da equipe de infusão",
    "Feriado": "Feriado",
    "Relacionado à logística": "Relacionado à logística",
    "Restrições impostas federais/estaduais/municipais": "Restrições impostas federais/estaduais/municipais",
    "Nenhum inventário no local de infusão": "Nenhum inventário no local de infusão",
}

export function formatPercent(raw) {
    const num = parseFloat(raw);
    if (isNaN(num)) return '-';
    
    const isInt = Number.isInteger(num);
    return num
        .toLocaleString('pt-BR', {
        minimumFractionDigits: isInt ? 0 : 2,
        maximumFractionDigits: isInt ? 0 : 2
    })
    + '%';
}

export function calcularIdade(dataNascimento) {
    let nascimento;

    if (typeof dataNascimento === 'string') {
        const dataOnly = dataNascimento.split('T')[0];

        if (dataOnly.includes('/')) {
            const [dia, mes, ano] = dataOnly.split('/');
            nascimento = new Date(+ano, +mes - 1, +dia);
        } else if (dataOnly.includes('-')) {
            const [ano, mes, dia] = dataOnly.split('-');
            nascimento = new Date(+ano, +mes - 1, +dia);
        } else {
            nascimento = new Date(dataNascimento);
        }
    } else {
        // já é Date ou timestamp
        nascimento = new Date(dataNascimento);
    }

    const hoje = new Date();
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const m = hoje.getMonth() - nascimento.getMonth();

    if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--;
    }
    return idade;
}

export const kitsStatus = {
    agendado: "Agendado",
    enviado: "Enviado",
    cancelado: "Cancelado"
};

const isBusinessDay = (d) => {
  const wd = d.getDay();
  return wd !== 0 && wd !== 6;
};

const isHoliday = (d, holidays = []) => {
  if (!Array.isArray(holidays) || holidays.length === 0) return false;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const iso = `${yyyy}-${mm}-${dd}`;
  return holidays.includes(iso);
};

export const addBusinessDays = (startDate, days, holidays = []) => {
  if (!(startDate instanceof Date) || Number.isNaN(startDate)) return null;
  let remaining = Number(days) || 0;
  const out = new Date(startDate.getTime()); // mantém hora

  while (remaining > 0) {
    out.setDate(out.getDate() + 1);
    if (isBusinessDay(out) && !isHoliday(out, holidays)) {
      remaining -= 1;
    }
  }

  return out;
};

export const statusAplicacoes = {
    agendada: "Agendada",
    realizada: "Realizada",
    nao_realizada: "Não Realizada",
    reagendada: "Reagendada",
}

export const formatFileSize = (bytes) => {
    if (bytes === 0 || !bytes) return '0 B';

    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return (bytes / Math.pow(k, i)).toFixed(1).replace('.', ',') + ' ' + units[i];
};

/**
 * Substitui variáveis em um texto por valores dinâmicos
 * @param {string} text - Texto com variáveis no formato [nome_variavel]
 * @param {object} variables - Objeto com os valores das variáveis
 * @returns {string} - Texto com as variáveis substituídas
 * 
 * @example
 * replaceTextVariables("Aceito os termos do [programa_nome]", { programa_nome: "Programa X" })
 * // retorna: "Aceito os termos do Programa X"
 */
export const replaceTextVariables = (text, variables = {}) => {
    if (!text || typeof text !== 'string') {
        return text;
    }

    let result = text;

    Object.keys(variables).forEach(key => {
        const regex = new RegExp(`\\[${key}\\]`, 'g');
        const value = variables[key] !== null && variables[key] !== undefined ? variables[key] : '';
        result = result.replace(regex, value);
    });

    return result;
}

/**
 * Verifica se o usuário atual se enquadra em uma lista de perfis configurada
 * em `configuracoes` do programa. Usado pelas regras de bloqueio por perfil.
 *
 * Aliases aceitos na lista:
 *  - `medico` → `medicos`
 *  - `administrador` → `''` (tipo_usuario vazio, equivalente a admin/superuser)
 *
 * Compara contra `tipo_usuario`; quando este é `prestador`, também compara
 * contra `prestador_categoria`.
 */
const matchesPerfilUsuarioAtual = (perfis) => {
    if (!Array.isArray(perfis) || perfis.length === 0) return false;

    const dados_usuario = getCurrentUser();
    const tipoUsuario = dados_usuario?.tipo_usuario || '';
    const perfisNormalizados = perfis.map((p) => {
        if (p === 'medico') return 'medicos';
        if (p === 'administrador') return '';
        return p;
    });

    return perfisNormalizados.includes(tipoUsuario) ||
        (tipoUsuario === 'prestador' && perfisNormalizados.includes(dados_usuario?.prestador_categoria));
};

/**
 * Verifica se a visualização de laudos está bloqueada para o usuário atual
 * conforme as configurações do programa.
 *
 * Configurações suportadas (a nova tem precedência sobre a legada):
 *  - `exames.perfis_bloquear_laudo` (array): bloqueia apenas para os perfis
 *    listados (ver {@link matchesPerfilUsuarioAtual}).
 *  - `bloqueado_visualizar_laudo` (boolean, legado): se true e a chave acima
 *    não estiver definida, bloqueia para todos.
 */
export const isLaudoBloqueadoParaUsuarioAtual = (configuracoes) => {
    const perfisBloqueados = getConfig(configuracoes, 'exames.perfis_bloquear_laudo', null);
    if (Array.isArray(perfisBloqueados)) {
        return matchesPerfilUsuarioAtual(perfisBloqueados);
    }
    return Boolean(getConfig(configuracoes, 'bloqueado_visualizar_laudo', false));
};

/**
 * Verifica se a visualização das respostas/dados da confirmação do serviço
 * está bloqueada para o usuário atual.
 *
 * Configuração: `agendamento.perfis_bloquear_dados_confirmacao_servico` (array
 * de perfis — ver {@link matchesPerfilUsuarioAtual}).
 */
export const isDadosConfirmacaoBloqueadosParaUsuarioAtual = (configuracoes) => {
    const perfisBloqueados = getConfig(
        configuracoes,
        'agendamento.perfis_bloquear_dados_confirmacao_servico',
        null
    );
    return matchesPerfilUsuarioAtual(perfisBloqueados);
};

/**
 * A aba "Laboratórios" do cadastro do profissional atende quem opera o vínculo
 * médico x laboratório: o administrador (tipo_usuario vazio, que também é o caso
 * do superuser) enxerga em qualquer programa, e a operação -- navegadora (operador)
 * e gestor interno -- só nos programas que pedirem a aba em suas configurações:
 *
 *   "medicos": { "exibir_laboratorios": true }
 *
 * É opt-in porque hoje só o IDHentifique trabalha esse vínculo; sem a chave a aba
 * não aparece. O gestor da indústria fica de fora: `tipo_gestor` é 'industria' ou
 * 'interno', e só o interno acompanha a rede de laboratórios.
 *
 * @param {*} configuracoes - configurações do programa do cadastro aberto.
 */
export const podeVerLaboratoriosPrestador = (configuracoes) => {
    if (isSuperUser(getCurrentUser())) {
        return true;
    }

    if (getConfig(configuracoes, 'medicos.exibir_laboratorios', false) !== true) {
        return false;
    }

    const tipos_acesso = tiposAcesso();

    return 'operador' in tipos_acesso || tipos_acesso?.gestor?.tipo_gestor === 'interno';
};

/**
 * O resultado do exame passa a ser informado DEPOIS da confirmação da realização,
 * pelo formulário de evento `onApproveLaudo`, em vez de junto com o anexo do laudo.
 *
 * Nasceu do Compass PSD (HNS-1610): com a troca do laboratório para a Mendelics o
 * positivo/negativo só chega no relatório mensal, então a navegadora anexa o documento
 * avisando o médico e volta depois para classificar. Enquanto a flag está ligada:
 *  - o formulário não abre no momento da confirmação;
 *  - a avaliação (aprovar/recusar) do arquivo sai de cena — o programa não usa esse fluxo,
 *    e recusar devolveria o agendamento para `arquivo_pendente`, desfazendo a realização;
 *  - aparece a ação de informar o resultado enquanto o agendamento não tiver resposta.
 *
 * Configuração: `agendamento.formulario_resultado_apos_aprovacao` (boolean).
 */
export const isResultadoExameAposConfirmacao = (configuracoes) => {
    return getConfig(configuracoes, 'agendamento.formulario_resultado_apos_aprovacao', false) === true;
};

/**
 * Verifica se a criação/edição manual de agendamentos está bloqueada para o
 * usuário atual conforme a configuração do programa.
 *
 * Configuração: `agendamento.bloquear_edicao` (boolean). Quando true, bloqueia
 * a tela de add/edit (/agendamentos/add e /agendamentos/edit) e os botões que
 * levam a ela. O superadmin nunca é bloqueado, para permitir correções manuais
 * sem desligar a flag. A criação automática de agendamentos pelo fluxo do
 * programa não passa por esta tela e segue funcionando.
 */
export const isEdicaoAgendamentoBloqueada = (configuracoes) => {
    if (isSuperUser(getCurrentUser())) return false;
    return getConfig(configuracoes, 'agendamento.bloquear_edicao', false) === true;
};

export const TiposCadastroMedico = {
    programa: "Programa",
    cliente: "Cliente"
};

/**
 * O prestador pode reagendar o proprio agendamento quando:
 *  - tem `permite_agendar_servico=true` no cadastro (ja usado em AtendimentosEdit)
 *  - e o agendamento sendo listado e dele mesmo
 * Assim, na PTC a psicologa reagenda o proprio slot; medico/lab do mesmo programa
 * continuam sem editar (a flag esta ligada so em quem tem responsabilidade da agenda).
 * `prestadorLogado` e o resultado de getCurrentUser() e `agendamento` e um item da lista.
 */
export const prestadorPodeEditarProprioAgendamento = (prestadorLogado, agendamento) => {
    if (!prestadorLogado || prestadorLogado.tipo_usuario !== 'prestador') return false;
    if (!prestadorLogado.permite_agendar_servico) return false;
    const idLogado = prestadorLogado.prestador_id ?? prestadorLogado.prestador?.id;
    const idAgendamento = agendamento?.prestador_id ?? agendamento?.dados_prestador?.id;
    if (!idLogado || !idAgendamento) return false;
    return String(idLogado) === String(idAgendamento);
};

// Usuario logado eh um medico (prestador com categoria medicos). Serve para gates
// de mensagens/UI direcionadas so ao medico (ex.: pop-up de solicitacao de exame).
export const ehMedicoLogado = (usuario) => {
    if (!usuario) return false;
    return usuario.tipo_usuario === 'prestador' && usuario.prestador_categoria === 'medicos';
};

/**
 * Mensagem de sucesso ao concluir a etapa, resolvida por perfil.
 *
 * A etapa tem um unico `mensagem_sucesso_finalizacao`, entao um texto escrito para quem
 * executa ("um profissional do programa entrara em contato") aparecia igual para a operacao,
 * que e justamente quem vai fazer o contato. A variante por perfil vem da configuracao da
 * etapa, sem campo novo no banco:
 *
 *   configuracoes.mensagem_sucesso_finalizacao_medico     -> so para o medico
 *   configuracoes.mensagem_sucesso_finalizacao_prestador  -> demais prestadores (psicologa, nutri)
 *
 * Ordem: medico -> prestador -> sentinela legada `aviso_solicitacao_exame` -> campo da etapa
 * -> padrao. Etapas sem configuracao seguem exatamente como antes.
 */
export const resolverMensagemSucessoEtapa = (etapa, usuario, padrao = i18n.t('atendimentosEdit:etapaModal.etapaConcluida')) => {
    const mensagem = etapa?.mensagem_sucesso_finalizacao;
    const configuracoes = etapa?.configuracoes;

    if (usuario?.tipo_usuario === 'prestador') {
        if (ehMedicoLogado(usuario)) {
            const doMedico = getConfig(configuracoes, 'mensagem_sucesso_finalizacao_medico', '');
            if (doMedico) return doMedico;
        }
        const doPrestador = getConfig(configuracoes, 'mensagem_sucesso_finalizacao_prestador', '');
        if (doPrestador) return doPrestador;
    }

    // Sentinela legada: texto fixo no codigo, so para o medico.
    if (mensagem === 'aviso_solicitacao_exame') {
        return ehMedicoLogado(usuario)
            ? 'Caso o paciente não atenda aos critérios de elegibilidade, um profissional do programa entrará em contato.'
            : padrao;
    }

    return mensagem || padrao;
};

/**
 * Indica se o programa usa o fluxo integrado exame↔agendamento↔serviço
 * (config `exames.sync_exame_agendamento`). Serve de porta única para as
 * partes do front que só fazem sentido nesse fluxo (guardrail de agendamento
 * manual, aba beta unificada). Fora dele, tudo segue o comportamento antigo.
 */
export const isFluxoExamesIntegradoAtivo = (configuracoes) => {
    return getConfig(configuracoes, 'exames.sync_exame_agendamento', false) === true;
};

/**
 * Agendamento cujo encontro já terminou. Serve para esconder o que só faz sentido
 * antes ou durante a sessão — entrar na sala de vídeo, copiar ou enviar o link ao
 * paciente. Fica aqui porque a mesma regra vale na listagem, na agenda e na aba de
 * agendamentos do atendimento.
 */
export const agendamentoEncerrado = (situacao) => {
    return ['finalizado', 'cancelado'].includes(situacao);
};

/**
 * Telefone só com dígitos vira legível: 47999887744 -> (47) 99988-7744.
 *
 * Os campos com máscara gravam o número limpo (`unmask="typed"`), que é o certo para o
 * banco -- mas exibir assim faz o usuário ler dígito a dígito.
 */
export const formataTelefoneExibicao = (valor) => {
    const digitos = String(valor ?? "").replace(/\D/g, "");
    if (digitos.length === 11) return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`;
    if (digitos.length === 10) return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`;
    return String(valor ?? "");
};
